import { isDefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../types.ts';

export const selectAccount = (state: RootState) => state.account;
export const selectUser = createSelector(
  selectAccount,
  ({ email, firstName, lastName, phone, id }) => ({
    email,
    firstName,
    lastName,
    phone,
    id,
  }),
);

export const selectFullNameWithDefault = createSelector(
  [selectUser, (state: RootState, defaultName?: string) => defaultName],
  ({ firstName, lastName }, defaultName) => {
    if (isDefined(firstName) || isDefined(lastName)) {
      return `${firstName} ${lastName}`.trim();
    }
    return defaultName;
  },
);

export const selectMLSIDs = createSelector(selectAccount, ({ mlsIDs }) => mlsIDs);
export const selectDefaultMLSID = createSelector(selectMLSIDs, (mlsIDs) => mlsIDs[0]);

export const selectIsOnboardingComplete = createSelector(
  selectAccount,
  ({ isOnboardingComplete }) => isOnboardingComplete,
);

export const selectFTUXes = createSelector(selectAccount, ({ ftux }) => ftux);

export const selectMcKissockData = createSelector(
  selectAccount,
  ({ mcKissockData }) => mcKissockData,
);

export const selectUserType = createSelector(selectAccount, ({ userType }) => userType);
